AOS.init();

// Function to get the current cart item count
function updateCartItemCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const itemsCount = cart.item_count;
      // Update the cart item count in real-time
      document.querySelector('.items-count-block').textContent = itemsCount;
    })
    .catch(error => console.error('Error fetching cart data:', error));
}

// Call the function to update cart item count on page load
document.addEventListener('DOMContentLoaded', updateCartItemCount);

// Optional: You can also call updateCartItemCount when cart changes (like adding/removing items)
document.addEventListener('cart:updated', updateCartItemCount);



// JavaScript function to switch between tabs

function showField(field) {
  // Hide both fields
  document.getElementById("number-field").classList.remove("active");
  document.getElementById("email-field").classList.remove("active");

  // Show the selected field
  document.getElementById(field + "-field").classList.add("active");

  // Update tab styling
  document.getElementById("tab-number").classList.remove("active");
  document.getElementById("tab-email").classList.remove("active");
  document.getElementById("tab-" + field).classList.add("active");
}

document.addEventListener("DOMContentLoaded", function () {
  const popupButton = document.getElementById("popuptriggerbutton");
  const popup = document.getElementById("customer-popup-form-block");
  const closeButton = document.querySelector(
    ".customer-popup-form-closebutton"
  );

  if (popupButton && popup) {
    // Open the popup
    popupButton.addEventListener("click", function () {
      popup.classList.add("popup-open");
    });
  }

  if (closeButton) {
    // Close the popup
    closeButton.addEventListener("click", function () {
      popup.classList.remove("popup-open");
    });
  }
});

// Menu active state
document.addEventListener("DOMContentLoaded", () => {
  const menuLinks = document.querySelectorAll(".st-vera-header-menu a");

  menuLinks.forEach((link) => {
    if (link.href === window.location.href) {
      link.classList.add("active");
    } else {
      link.classList.remove("active");
    }
  });
});

// Hamburger Menu

document.addEventListener("DOMContentLoaded", function () {
  const hamburgerToggle = document.querySelector(".hambuger-icon");
  const mobileHamburger = document.querySelector(".mobile-hamburger");
  const closeHamburger = document.querySelector(".mobile-hamburger-close");

  hamburgerToggle.addEventListener("click", function () {
    mobileHamburger.classList.remove("hidden");
    document.documentElement.classList.add("overflow-hidden");
    setTimeout(() => {
      mobileHamburger.classList.add("translate-0");
    }, 0);
  });

  closeHamburger.addEventListener("click", function () {
    mobileHamburger.classList.remove("translate-0");

    setTimeout(() => {
      mobileHamburger.classList.add("hidden");
      document.documentElement.classList.remove("overflow-hidden");
    }, 300);
  });
});


// $(document).ready(function () {
//   function initializeSlick() {
//     if ($(window).width() < 768) {
//       if (!$(".st-vera-guides-items-block").hasClass("slick-initialized")) {
//         $(".st-vera-guides-items-block").slick({
//           infinite: true,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           autoplay: true,
//           autoplaySpeed: 2000,
//           dots: false,
//           arrows: false,
//         });
//       }
//     } else {
//       if ($(".st-vera-guides-items-block").hasClass("slick-initialized")) {
//         $(".st-vera-guides-items-block").slick("unslick");
//       }
//     }
//   }

  
//   initializeSlick();

//   $(window).resize(function () {
//     initializeSlick();
//   });
// });

// function checkScreenSize() {
//   const restrictedDiv = document.getElementById("restrictedAccess");

//   if (window.innerWidth > 767) {
//     restrictedDiv.style.display = "flex";
//   } else {
//     restrictedDiv.style.display = "none";
//   }
// }

// window.addEventListener("load", checkScreenSize);

// window.addEventListener("resize", checkScreenSize);
